import axios from "axios";

const coreBaseUrl = process.env.REACT_APP_CORE_URL;

const externalPageApi = {
  respondPendingAssignee: async (payload = {}) => {
    const response = await axios.post(
      `${coreBaseUrl}/cta/exposed/respond/pendingAssignee`,
      payload
    );
    return response;
  },

  respondPurchaseOrder: async (payload = {}) => {
    const response = await axios.post(
      `${coreBaseUrl}/cta/exposed/respond/respondPO`,
      payload
    );
    return response;
  },

  respondRequestPayment: async (payload = {}) => {
    const response = await axios.post(
      `${coreBaseUrl}/cta/exposed/request/requestPayment`,
      payload
    );
    return response;
  },
};

export default externalPageApi;
